<template>
  <div class="animated fadeIn">
    <!-- <StyledDialog>
      <div slot="header">
        <h2>{{dealership.dealership_edit.CommonName}}</h2>
      </div>
      <div slot="details">
        <div>{{dealership.dealership_edit.Address1}} {{dealership.dealership_edit.Address2}}</div>
        <div>{{dealership.dealership_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>-->

    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <CoolSelect
                  v-model="campaign.campaign_edit.Dealership.DealershipID"
                  class="form-input dropdown-content"
                  placeholder="Dealership"
                  theme="bootstrap"
                  tooltip="Dealerships"
                  :items="dealership.dealerships"
                  item-text="CommonName"
                  item-value="DealershipID"
                  id="DealershipID"
                  @select="manuallyAddDirtyField('DealershipID')"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth">Dealership</b-input-group-text>
                    </b-input-group-prepend>
                  </template>
                  <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
                  </template>-->
                </CoolSelect>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Ordered By</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="campaign.campaign_edit.BelongsTo.FullName"
                    placeholder="Ordered By"
                    type="text"
                    autocomplete="off"
                    id="OrderedBy"
                    disabled
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">PO Number</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.PONumber"
                    placeholder="Purchase Order Number"
                    required
                    type="text"
                    autocomplete="off"
                    id="PONumber"
                    @change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Description</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.Description"
                    placeholder="Campaign Description"
                    required
                    type="text"
                    autocomplete="off"
                    id="Description"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Mail Date</b-input-group-text>
                  </b-input-group-prepend>
                  <datepicker
                    disabled
                    @dp-change="addDirtyField"
                    :value="campaign.campaign_edit.RequestedMailDate"
                    :config="options"
                    id="MailDate"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>-->
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">In-home Date</b-input-group-text>
                  </b-input-group-prepend>
                  <datepicker
                    required
                    @dp-change="addDirtyField"
                    :value="campaign.campaign_edit.RequestedInHomeDate"
                    :config="options"
                    id="InHomeDate"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Postage Class</b-input-group-text>
                  </b-input-group-prepend>
                  <b-select
                    class="dropdown"
                    v-model="campaign.campaign_edit.PostageClass"
                    id="PostageClass"
                    @change="setDirtyField('PostageClass', campaign.campaign_edit.PostageClass)"
                  >
                    <option v-for="pc in PostageClasses" :key="pc">{{ pc }}</option>
                  </b-select>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Status</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.StatusCode"
                    disabled
                    type="text"
                    autocomplete="off"
                    id="StatusCode"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="campaign.campaign_edit.DateApproved">
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Date Approved</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.DateApproved"
                    disabled
                    type="text"
                    autocomplete="off"
                    id="ApprovedDate"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Approved By</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.Approver.FullName"
                    disabled
                    type="text"
                    autocomplete="off"
                    id="ApprovedBy"
                  ></b-form-input>
                  <!-- <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star appendIcon"></i>
                    </b-input-group-text>
                  </b-input-group-append>-->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="campaign.campaign_edit.CompletedDate">
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Date Mail Sent</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.DateCompleted"
                    disabled
                    type="text"
                    autocomplete="off"
                    id="CompletedDate"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      class="standardizedLongWidth"
                      :disabled="campaign.campaign_edit.DateApproved"
                      size="md"
                      variant="primary"
                      @click="$refs.ArtworkTargetUrlFile.click()"
                    >
                      <!-- <i class="fa fa-file-pdf"></i> -->
                      <!-- <i class="fa fa-spinner normal-spin"></i> -->
                      <span v-if="isTargetArtworkLoading">
                        <i class="fa fa-circle-o-notch fa-lg fa-spin"></i>
                        Uploading...
                      </span>
                      <span v-if="!isTargetArtworkLoading">Upload Artwork (Target)</span>
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.ArtworkTargetUrl"
                    placeholder="No Artwork Set"
                    type="text"
                    autocomplete="off"
                    disabled
                    ref="ArtworkTargetUrlInput"
                  ></b-form-input>
                  <input
                    type="file"
                    @change="onArtworkSelected($event, 'Artwork', 'ArtworkTargetUrl')"
                    accept=".pdf"
                    id="ArtworkTargetUrl"
                    style="display: none;"
                    ref="ArtworkTargetUrlFile"
                  />
                  <b-input-group-append v-if="campaign.campaign_edit.ArtworkTargetUrl">
                    <b-input-group-text>
                      <i
                        class="fa fa-download appendIcon"
                        @click="onArtworkDownload('ArtworkTargetUrl')"
                      ></i>
                      <i
                        class="ml-3 fa fa-trash appendIcon"
                        @click="onAssetRemove('ArtworkTargetUrl')"
                      ></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      class="standardizedLongWidth"
                      :disabled="campaign.campaign_edit.DateApproved"
                      size="md"
                      variant="primary"
                      @click="$refs.ArtworkSubsetUrlFile.click()"
                    >
                      <span v-if="isSubsetArtworkLoading">
                        <i class="fa fa-circle-o-notch fa-lg fa-spin"></i>
                        Uploading...
                      </span>
                      <span v-if="!isSubsetArtworkLoading">Upload Artwork (Subset)</span>
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.ArtworkSubsetUrl"
                    placeholder="No Artwork Set"
                    type="text"
                    autocomplete="off"
                    disabled
                    ref="ArtworkSubsetUrlInput"
                  ></b-form-input>
                  <input
                    type="file"
                    @change="onArtworkSelected($event, 'Artwork', 'ArtworkSubsetUrl')"
                    accept=".pdf"
                    id="ArtworkSubsetUrl"
                    style="display: none;"
                    ref="ArtworkSubsetUrlFile"
                  />
                  <b-input-group-append v-if="campaign.campaign_edit.ArtworkSubsetUrl">
                    <b-input-group-text>
                      <i
                        class="fa fa-download appendIcon"
                        @click="onArtworkDownload('ArtworkSubsetUrl')"
                      ></i>
                      <i
                        class="ml-3 fa fa-trash appendIcon"
                        @click="onAssetRemove('ArtworkSubsetUrl')"
                      ></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      class="standardizedLongWidth"
                      :disabled="campaign.campaign_edit.DateApproved"
                      size="md"
                      variant="primary"
                      @click="$refs.MailingListTargetUrlFile.click()"
                    >
                      <span v-if="isTargetMailingListLoading">
                        <i class="fa fa-circle-o-notch fa-lg fa-spin"></i>
                        Uploading...
                      </span>
                      <span v-if="!isTargetMailingListLoading">Upload Mail List (Target)</span>
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.MailingListTargetUrl"
                    placeholder="No Mailing List Set"
                    type="text"
                    autocomplete="off"
                    disabled
                    ref="MailingListTargetUrlInput"
                  ></b-form-input>
                  <input
                    type="file"
                    @change="onArtworkSelected($event, 'MailingList', 'MailingListTargetUrl')"
                    accept=".csv, .txt, .xlsx"
                    id="MailingListTargetUrl"
                    style="display: none;"
                    ref="MailingListTargetUrlFile"
                  />
                  <b-input-group-append v-if="campaign.campaign_edit.MailingListTargetUrl">
                    <b-input-group-text>
                      <i
                        class="fa fa-download appendIcon"
                        @click="onArtworkDownload('MailingListTargetUrl')"
                      ></i>
                      <i
                        class="ml-3 fa fa-trash appendIcon"
                        @click="onAssetRemove('MailingListTargetUrl')"
                      ></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      class="standardizedLongWidth"
                      :disabled="campaign.campaign_edit.DateApproved"
                      size="md"
                      variant="primary"
                      @click="$refs.MailingListSubsetUrlFile.click()"
                    >
                      <span v-if="isSubsetMailingListLoading">
                        <i class="fa fa-circle-o-notch fa-lg fa-spin"></i>
                        Uploading...
                      </span>
                      <span v-if="!isSubsetMailingListLoading">Upload Mail List (Subset)</span>
                    </b-button>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model.lazy="campaign.campaign_edit.MailingListSubsetUrl"
                    placeholder="No Mailing List Set"
                    type="text"
                    autocomplete="off"
                    disabled
                    required
                    ref="MailingListSubsetUrlInput"
                  ></b-form-input>
                  <input
                    type="file"
                    @change="onArtworkSelected($event, 'MailingList', 'MailingListSubsetUrl')"
                    accept=".csv, .txt. .xlsx"
                    id="MailingListSubsetUrl"
                    style="display: none;"
                    ref="MailingListSubsetUrlFile"
                  />
                  <b-input-group-append v-if="campaign.campaign_edit.MailingListSubsetUrl">
                    <b-input-group-text>
                      <i
                        class="fa fa-download appendIcon"
                        @click="onArtworkDownload('MailingListSubsetUrl')"
                      ></i>
                      <i
                        class="ml-3 fa fa-trash appendIcon"
                        @click="onAssetRemove('MailingListSubsetUrl')"
                      ></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i class="fa fa-caret-down fa-lg mr-2" v-if="seen" @click="toggleVisibility" />
                    <i class="fa fa-caret-up fa-lg mr-2" v-if="!seen" @click="toggleVisibility" />
                    <span v-if="seen" @click="toggleVisibility">Campaign Assets</span>
                    <span v-if="!seen" @click="toggleVisibility">Close</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-archive"></i>
                        <span class="ml-1">Postal Receipts</span>
                      </template>
                      <br />
                      <b-link
                        v-if="hasPostalDocs"
                        :href="PostalPaperworkLink"
                      >Download Postal Documents</b-link>
                      <label v-if="!hasPostalDocs">Postal Documents are not currently available</label>
                    </b-tab>
                    <!-- <b-tab>
                      <template slot="title">
                        <i class="fa fa-archive"></i>
                        <span class="ml-1">Target Artwork</span>
                      </template>
                      <br />
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-archive"></i>
                        <span class="ml-1">Subset Artwork</span>
                      </template>
                      <br />
                    </b-tab>-->
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-archive"></i>
                        <span class="ml-1">Live Proofs</span>
                      </template>
                      <br />
                      <b-link
                        v-if="campaign.campaign_edit.CompletedDate"
                        :href="FullRunLink"
                        target="_blank"
                      >Download Live Print File</b-link>
                      <label
                        v-if="!campaign.campaign_edit.CompletedDate"
                      >Live files are not currently available</label>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-archive"></i>
                        <span class="ml-1">Activity</span>
                      </template>
                      <br />
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <div class="form-group form-actions" style="float:left;">
            <b-button
              class="mr-2 mt-2 btn btn-navyBlue"
              v-if="canSubmit && (campaign.campaign_edit.CampaignID > -1)"
              size="md"
              @click="submitOrder"
            >
              <i class="fa fa-thumbs-up"></i>
              Submit Order
            </b-button>
            <b-button
              class="mr-2 mt-2 btn btn-forestGreen"
              v-if="hasLiveProofs"
              size="md"
              @click="approve"
            >
              <i class="fa fa-thumbs-up"></i>
              Approve Order
            </b-button>
            <b-button
              class="ml-2 mt-2 btn btn-orange"
              type="submit"
              size="md"
              @click="newCampaign"
              :disabled="!isClean"
            >
              <i class="icon-plus"></i>
              Add Another
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-button
              v-if="!campaign.campaign_edit.DateApproved"
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              v-if="campaign.campaign_edit.DateApproved"
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Close
            </b-button>
            <b-button
              v-if="campaign.campaign_edit.StatusCode === 'Created'"
              class="mr-0 mt-2"
              type="submit"
              size="md"
              variant="primary"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
            <b-button
              v-if="campaign.campaign_edit.StatusCode !== 'Created'"
              class="mr-0 mt-2"
              @click="requestCancel"
              size="md"
              variant="danger"
            >
              <i class="fa fa-stop-circle"></i>
              Request Cancellation
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss4CountDown"
              fade
              variant="light"
              :dismissed="dismiss4Countdown=0"
              @dismiss-count-down="countDown4Changed"
            >
              Your request has been sent
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="dismissCountdown=0"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="dismiss2Countdown=0"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="dismiss3Countdown=0"
              @dismiss-count-down="countDown3Changed"
            >Artwork and Mailing List must be selected for at least one segment.</b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LocationRow from "@/components/CustomRowComponents/LocationRow.vue";
import ContactRow from "@/components/CustomRowComponents/ContactRow.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import { CoolSelect } from "vue-cool-select";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import moment from "moment";
import firebase from "firebase/app";
import FirebaseUploader from "../../assets/FirebaseUploader.js";

export default {
  name: "CampaignEdit",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      imageUrl: "",
      image: null,
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      dismiss4Secs: 3,
      dismiss4CountDown: 0,
      showDismissibleAlert: false,
      TargetArtwork: null,
      TargetData: null,
      SubsetArtwork: null,
      SubsetData: null,
      isTargetArtworkLoading: false,
      isSubsetArtworkLoading: false,
      isTargetMailingListLoading: false,
      isSubsetMailingListLoading: false,
      PostageClasses: ["First Class", "Standard"],
      options: {
        format: "MM/DD/YYYY",
        useCurrent: true,
        minDate: new Date(),
        daysOfWeekDisabled: [0, 6]
      }
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    countDown4Changed(dismiss4CountDown) {
      this.dismiss4CountDown = dismiss4CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    submitOrder() {
      if (
        (!this.$store.state.campaign.campaign_edit.ArtworkTargetUrl &&
          !this.$store.state.campaign.campaign_edit.ArtworkSubsetUrl) ||
        (this.$store.state.campaign.campaign_edit.ArtworkTargetUrl &&
          !this.$store.state.campaign.campaign_edit.MailingListTargetUrl) ||
        (this.$store.state.campaign.campaign_edit.ArtworkSubsetUrl &&
          !this.$store.state.campaign.campaign_edit.MailingListSubsetUrl)
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      this.dirtyFields.push(
        {
          FieldName: "SubmitDate",
          //FieldValue: moment(new Date()).format("YYYY-MM-DD")
          FieldValue: moment().format("MM/DD/YYYY")
        },
        {
          FieldName: "ApprovedBy",
          FieldValue: this.$store.state.n_user.n_current_user.UserProfileID
        },
        {
          FieldName: "StatusCode",
          FieldValue: "Submitted"
        }
      );
      this.$store.state.campaign.campaign_edit.StatusCode = "Submitted";
      this.$store.state.campaign.campaign_edit.Approver.FullName = this.$store.state.n_user.n_current_user.FullName;
      this.$store.state.campaign.campaign_edit.ApprovedBy = this.$store.state.n_user.n_current_user.UserProfileID;
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
      this.$store.state.campaign.campaign_edit.DateApproved = moment().format(
        "MM/DD/YYYY"
      );
      //this.$store.state.campaign.campaign_edit.ApprovedDate = moment();
      this.$store.dispatch("campaign/Notify", {
        campaign: this.$store.state.campaign.campaign_edit,
        status: 2,
        approvedBy: this.$store.state.campaign.campaign_edit.ApprovedBy
      });

      this.save();
    },
    approve() {
      this.dirtyFields.push(
        {
          FieldName: "ApprovedDate",
          //FieldValue: moment(new Date()).format("YYYY-MM-DD")
          FieldValue: moment().format("MM/DD/YYYY")
        },
        {
          FieldName: "ApprovedBy",
          FieldValue: this.$store.state.n_user.n_current_user.UserProfileID
        },
        {
          FieldName: "StatusCode",
          FieldValue: "Approved"
        }
      );
      this.$store.state.campaign.campaign_edit.StatusCode = "Approved";
      this.$store.state.campaign.campaign_edit.Approver.FullName = this.$store.state.n_user.n_current_user.FullName;
      this.$store.state.campaign.campaign_edit.ApprovedBy = this.$store.state.n_user.n_current_user.UserProfileID;
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
      this.$store.state.campaign.campaign_edit.DateApproved = moment().format(
        "MM/DD/YYYY"
      );
      //this.$store.state.campaign.campaign_edit.ApprovedDate = moment();
      this.$store.dispatch("campaign/Notify", {
        campaign: this.$store.state.campaign.campaign_edit,
        status: 3,
        approvedBy: this.$store.state.campaign.campaign_edit.ApprovedBy
      });

      this.save();
    },
    requestCancel() {
      this.$store
        .dispatch("campaign/Notify", {
          campaign: this.$store.state.campaign.campaign_edit,
          status: 4,
          approvedBy: this.$store.state.campaign.campaign_edit.ApprovedBy
        })
        .then((this.dismiss4CountDown = this.dismiss4Secs));
    },
    save() {
      this.$v.$touch();
      if (
        this.$v.$error ||
        !this.$store.state.campaign.campaign_edit.Dealership.DealershipID ||
        !this.$store.state.campaign.campaign_edit.PostageClass
      ) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );
      }
    },
    newCampaign() {
      this.$router.push({ name: "CampaignAddAnother" });
    },
    addLocation() {
      this.$store
        .dispatch("campaign/New")
        .then(() => {
          //this.$router.push({
          //  name: "Client"
          this.$bvModal.show("modal-3");
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    addDirtyField: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    manuallyAddDirtyField(id) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== id
      );
      this.dirtyFields.push({
        FieldName: id,
        FieldValue: this.$store.state.campaign.campaign_edit.Dealership
          .DealershipID
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    setDirtyField(id, value) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== id
      );
      this.dirtyFields.push({
        FieldName: id,
        FieldValue: value
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addReadOnlyFields() {
      if (this.$store.state.campaign.campaign_edit.CampaignID === -1) {
        this.dirtyFields = [];
        this.dirtyFields.push(
          {
            FieldName: "OrderedBy",
            FieldValue: this.$store.state.campaign.campaign_edit.OrderedBy
          },
          {
            FieldName: "OrderDate",
            FieldValue: moment().format("MM/DD/YYYY")
          },
          {
            FieldName: "RequestedMailDate",
            FieldValue: moment(this.$store.state.campaign.campaign_edit).format(
              "MM/DD/YYYY"
            ).RequestedMailDate
          },
          {
            FieldName: "InHomeDate",
            FieldValue: this.$store.state.campaign.campaign_edit
              .RequestedInHomeDate
          },
          {
            FieldName: "PostageClass",
            FieldValue: this.$store.state.campaign.campaign_edit.PostageClass
          },
          {
            FieldName: "StatusCode",
            FieldValue: "Created"
          }
        );

        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
      }
    },
    onArtworkSelected(event, directory, ref) {
      const file = event.target.files[0];

      // const fr = new FileReader();
      // fr.addEventListener("load", () => {
      //   this.imageUrl = fr.result;
      // });
      // fr.readAsDataURL(file);
      // this.image = file;
      var storageRef = firebase
        .storage()
        .ref()
        .child(directory + "/" + file.name);

      switch (ref) {
        case "ArtworkTargetUrl":
          this.isTargetArtworkLoading = true;
          break;
        case "ArtworkSubsetUrl":
          this.isSubsetArtworkLoading = true;
          break;
        case "MailingListTargetUrl":
          this.isTargetMailingListLoading = true;
          break;
        case "MailingListSubsetUrl":
          this.isSubsetMailingListLoading = true;
          break;
        default:
      }

      //var imageRef = storageRef.child('test.png')
      // Create a reference to 'mountains.jpg'
      //     var mountainsRef = storageRef.child('mountains.jpg')
      storageRef.put(file).then(() => {
        //console.log("Uploaded a blob or file!");
        //console.log(file.name);
        //console.log(event.target.id);
        this.setDirtyField(event.target.id, file.name);
        switch (ref) {
          case "ArtworkTargetUrl":
            this.$store.state.campaign.campaign_edit.ArtworkTargetUrl =
              file.name;
            this.isTargetArtworkLoading = false;
            break;
          case "ArtworkSubsetUrl":
            this.$store.state.campaign.campaign_edit.ArtworkSubsetUrl =
              file.name;
            this.isSubsetArtworkLoading = false;
            break;
          case "MailingListTargetUrl":
            this.$store.state.campaign.campaign_edit.MailingListTargetUrl =
              file.name;
            this.isTargetMailingListLoading = false;
            break;
          case "MailingListSubsetUrl":
            this.$store.state.campaign.campaign_edit.MailingListSubsetUrl =
              file.name;
            this.isSubsetMailingListLoading = false;
            break;
          default:
        }
      });
    },
    onAssetRemove(ref) {
      switch (ref) {
        case "ArtworkTargetUrl":
          this.$store.state.campaign.campaign_edit.ArtworkTargetUrl = "";
          this.setDirtyField("ArtworkTargetUrl", "");
          break;
        case "ArtworkSubsetUrl":
          this.$store.state.campaign.campaign_edit.ArtworkSubsetUrl = "";
          this.setDirtyField("ArtworkSubsetUrl", "");
          break;
        case "MailingListTargetUrl":
          this.$store.state.campaign.campaign_edit.MailingListTargetUrl = "";
          this.setDirtyField("MailingListTargetUrl", "");
          break;
        case "MailingListSubsetUrl":
          this.$store.state.campaign.campaign_edit.MailingListSubsetUrl = "";
          this.setDirtyField("MailingListSubsetUrl", "");
          break;
        default:
      }
    },
    onArtworkDownload(ref) {
      var stringFileName = "";
      var stringDirectory = "";
      switch (ref) {
        case "ArtworkTargetUrl":
          stringFileName = this.$store.state.campaign.campaign_edit
            .ArtworkTargetUrl;
          stringDirectory = "Artwork/";
          break;
        case "ArtworkSubsetUrl":
          stringFileName = this.$store.state.campaign.campaign_edit
            .ArtworkSubsetUrl;
          stringDirectory = "Artwork/";
          break;
        case "MailingListTargetUrl":
          stringFileName = this.$store.state.campaign.campaign_edit
            .MailingListTargetUrl;
          stringDirectory = "MailingList/";
          break;
        case "MailingListSubsetUrl":
          stringFileName = this.$store.state.campaign.campaign_edit
            .MailingListSubsetUrl;
          stringDirectory = "MailingList/";
          break;
        default:
      }

      var storageRef = firebase
        .storage()
        .ref()
        .child(stringDirectory + stringFileName)
        .getDownloadURL()
        .then(function(url) {
          window.open(url);
        });
    },
    onPickFile() {
    }
  },
  computed: {
    ...mapState(["campaign", "dealership"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    hasLiveProofs() {
      return (
        this.$store.state.campaign.campaign_edit.StatusCode ===
        "Live Proofs Available"
      );
    },
    hasPostalDocs() {
      return this.$store.state.campaign.campaign_edit.StatusCode === "Closed";
    },
    canSubmit() {
      return this.$store.state.campaign.campaign_edit.StatusCode === "Created";
    },
    PostalPaperworkLink() {
      return (
        "/PostalDocuments/" +
        this.$store.state.campaign.campaign_edit.Internal +
        ".zip"
      );
    },
    FullRunLink() {
      return (
        "/LiveFiles/" +
        this.$store.state.campaign.campaign_edit.Internal +
        ".pdf"
      );
    }
  },
  components: {
    LocationRow,
    ContactRow,
    StyledDialog,
    CoolSelect,
    datepicker,
    moment,
    firebase,
    FirebaseUploader
  },
  created() {
    this.$store.dispatch("dealership/fetchDealerships");
  },
  mounted() {
    this.addReadOnlyFields();
    this.$store.state.saveOp.localUrl = "/Campaign/Save/";
    this.$store.state.saveOp.localVariableName = "_c";
    this.$store.state.saveOp.localVariableObject = this.$store.state.campaign.campaign_edit;
    this.$store.state.saveOp.localFieldToSet = "CampaignID";
    this.$store.state.saveOp.localReturnObject = "SaveResult";
  },
  validations: {
    campaign: {
      campaign_edit: {
        PONumber: {
          required
        },
        Description: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
